<template>
  <div>
    <template v-if="petition.signatureFormHidden">
      <h2> {{ i18n.t('petitions.view.show.closed') }} </h2>
      <span> {{ i18n.t('petitions.view.sign_form.disabled') }} </span>
    </template>

    <template v-else>
      <progress-and-recent-signatures />

      <h3 v-if="petition.signersWriteToDecisionMaker" class="mt-0 mb-3">
        {{ i18n.t('petitions.view.sign_form.your_details') }}
      </h3>
      <h2 v-else-if="showSidebarForScreenSize">
        {{ signTitle }}
      </h2>

      <div class="sign-petition-form">
        <template v-if="oneClickFromContext">
          <p>{{ actionTakerName }}</p>
          <not-me-link :user-name="actionTakerName" context="prefill_signature" />
        </template>
        <template v-if="oneClickFromCrm">
          <p>
            <strong>
              {{ i18n.t('public.one_click.welcome_back', {name: actionTakerName}) }}
            </strong>
          </p>
          <not-me-link :user-name="actionTakerName" context="one_click_sign" />
        </template>

        <sign-form />

        <div v-if="showDataProcessingConsentAfterSubmit" class="small-text mt-2" v-html="dataProcessingConsentLabel" />
        <div class="signature-disclaimer small-text mt-2" v-html="disclaimerContent.afterSubmit" />
        <bot-protection-disclaimer v-if="botProtectionEnabled" />
      </div>
    </template>
  </div>
</template>

<script>
import BotProtectionDisclaimer from '@/components/inputs/bot-protection-disclaimer'
import { mapGetters, mapState } from 'vuex'
import NotMeLink from './not-me-link'
import ProgressAndRecentSignatures from './progress-and-recent-signatures'
import SignForm from './form'

export default {
  components: { BotProtectionDisclaimer, NotMeLink, ProgressAndRecentSignatures, SignForm },

  computed: {
    ...mapGetters(['dataProcessingConsentLabel', 'showDataProcessingConsentAfterSubmit', 'showSidebarForScreenSize']),
    ...mapState(['actionTakerName', 'disclaimerContent', 'oneClickFromContext', 'oneClickFromCrm', 'petition',
                 'signTitle']),

    botProtectionEnabled() {
      return this.agraConfiguration.botProtection.kind !== 'none'
    }
  }
}
</script>
